import React from "react";
import { NavLink, Outlet, Link } from "react-router-dom";
import { LayoutDashboard, Package, ShoppingBag, Users, ArrowLeft, Tag, Settings, Image as ImageIcon, Zap, BarChart3 } from "lucide-react";
import { useAuth } from "../../context/AuthContext";

const NAV = [
  { to: "/admin", label: "Overview", icon: LayoutDashboard, end: true },
  { to: "/admin/products", label: "Products", icon: Package },
  { to: "/admin/orders", label: "Orders", icon: ShoppingBag, fullAdminOnly: true },
  { to: "/admin/customers", label: "Customers", icon: Users },
  { to: "/admin/traffic", label: "Traffic", icon: BarChart3 },
  { to: "/admin/coupons", label: "Coupons", icon: Tag },
  { to: "/admin/media", label: "Media", icon: ImageIcon },
  { to: "/admin/integrations", label: "Integrations", icon: Zap },
  { to: "/admin/settings", label: "Settings", icon: Settings },
];

export default function AdminLayout() {
  const { user } = useAuth();
  const navItems = NAV.filter((item) => !item.fullAdminOnly || user?.role === "admin");
  return (
    <div className="min-h-screen grid grid-cols-12 bg-secondary">
      <aside
        data-testid="admin-sidebar"
        className="col-span-12 lg:col-span-2 bg-ink text-white p-6 lg:min-h-screen"
      >
        <Link to="/" className="flex items-center gap-2 mb-10 text-white/80 hover:text-white text-xs font-mono uppercase tracking-[0.2em]">
          <ArrowLeft size={14} /> Back to site
        </Link>
        <div className="flex items-center gap-2 mb-1">
          <img
            src="/icons/icon-192.png"
            alt="Shamstrade"
            className="w-8 h-8 object-contain bg-white rounded p-0.5"
          />
          <div className="font-display font-black text-xl">SHAMSTRADE</div>
        </div>
        <div className="text-[10px] font-mono uppercase tracking-[0.3em] text-electric mb-8">
          Admin Console
        </div>
        <nav className="space-y-1">
          {navItems.map(({ to, label, icon: Icon, end }) => (
            <NavLink
              key={to}
              to={to}
              end={end}
              data-testid={`admin-nav-${label.toLowerCase()}`}
              className={({ isActive }) =>
                `flex items-center gap-3 px-3 h-11 text-xs font-mono uppercase tracking-[0.2em] ${
                  isActive
                    ? "bg-electric text-white"
                    : "text-white/70 hover:bg-white/10 hover:text-white"
                }`
              }
            >
              <Icon size={14} /> {label}
            </NavLink>
          ))}
        </nav>
      </aside>

      <main className="col-span-12 lg:col-span-10 bg-white min-h-screen">
        <div className="px-6 md:px-10 py-8 max-w-[1400px]">
          <Outlet />
        </div>
      </main>
    </div>
  );
}
